import clsx from "clsx";
import * as React from "react";
import { useSelector } from "react-redux";

import { Button, makeStyles, Theme } from "@material-ui/core";
import PersonIcon from "@material-ui/icons/Person";

import RootState from "../../state/root/RootState";
import { Links } from "../root/PageManager";

// STYLES
const useStyles = makeStyles(
  (theme: Theme) => ({
    iconSmall: {
      fontSize: 20,
    },
    leftIcon: {
      marginRight: theme.spacing(1),
    },
    logoutBtn: {
      margin: "5px",
      "&:hover": {
        backgroundColor: "white",
      },
      "&:focus": {
        margin: "3px",
        border: "black 2px solid",
        transitionDuration: "0ms",
      },
    },
  }),
  { index: 1 }
);

export default function LogoutButton() {
  const classes = useStyles();
  const user = useSelector((state: RootState) => state.AuthenticationReducer.user);
  return (
    <Button disableFocusRipple={true} className={classes.logoutBtn} size="small" color="inherit" component={Links.LogoutLink.ToButtonComponent}>
      <PersonIcon aria-hidden={undefined} role="img" aria-label="logout" className={clsx(classes.leftIcon, classes.iconSmall)} />
      {Links.LogoutLink.Title}
    </Button>
  );
}
